<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="alertSucesso = false"></app-success-generico>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="alertError = false"></app-error-generico>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
